export const GET_ALL_APPOINTMENTS = 'GET_ALL_APPOINTMENTS'
export const GET_ALL_APPOINTMENTS_AUCTION = 'GET_ALL_APPOINTMENTS_AUCTIONS'
export const GET_SINGLE_APPOINTMENT = 'GET_SINGLE_APPOINTMENTS'
export const GET_ALL_LOCATIONS = 'GET_ALL_LOCATIONS'
export const GET_ALL_CALENDARS = 'GET_ALL_CALENDARS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
